import React from 'react';

const Aboutus = () => {
    return (
        <section id="aboutus" className="bg-white">
            <div className="container">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <h2 className="text-dark">The One.all Initiative<br/></h2>
                        <hr className="my-4 mx-auto" />
                        <p className="text-faded mb-4">We are pleased to present you a bundle of quality services under one roof. We work in a variety of domains such as Education, A/V content development, Web application development and many more. We are skilled at using different
                            technologies and platforms as per the requirement of the project. And we are always eager to expand our skillset. Please mention your friends and families about our initiative. Thank you for investing your valuable time.<br/></p>
                        <a className="btn btn-warning btn-xl js-scroll-trigger" role="button" href="#team">Know Us!</a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Aboutus